import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import s from 'components/bolt/counter/counter.sss';


export default class Counter extends Component {

	render({ numTicketsSelected, minusDisabled, plusDisabled, minusOnClick, plusOnClick, extraClass }) {
		return (
			<div class={joinClasses(s.counter, extraClass)}>
				<div class={joinClasses(s.minus, minusDisabled && s.inactive)} role="button" alt="fewer" onClick={minusOnClick} />
				<span class={s.num}>{numTicketsSelected}</span>
				<div class={joinClasses(s.plus, plusDisabled && s.inactive)} role="button" alt="more" onClick={plusOnClick} />
			</div>
		);
	}
}